/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsMachineLicenseListItem
 */
export interface ControlcenterMelcoModelsMachineLicenseListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    license_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    is_subscription?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    level?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    status?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    renewal_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    expiration_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicenseListItem
     */
    cancelled_on?: Date | null;
}

export function ControlcenterMelcoModelsMachineLicenseListItemFromJSON(json: any): ControlcenterMelcoModelsMachineLicenseListItem {
    return ControlcenterMelcoModelsMachineLicenseListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsMachineLicenseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsMachineLicenseListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'license_count': !exists(json, 'license_count') ? undefined : json['license_count'],
        'is_subscription': !exists(json, 'is_subscription') ? undefined : json['is_subscription'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'renewal_date': !exists(json, 'renewal_date') ? undefined : (json['renewal_date'] === null ? null : new Date(json['renewal_date'])),
        'expiration_date': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
        'cancelled_on': !exists(json, 'cancelled_on') ? undefined : (json['cancelled_on'] === null ? null : new Date(json['cancelled_on'])),
    };
}

export function ControlcenterMelcoModelsMachineLicenseListItemToJSON(value?: ControlcenterMelcoModelsMachineLicenseListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_name': value.user_name,
        'transaction_id': value.transaction_id,
        'license_count': value.license_count,
        'is_subscription': value.is_subscription,
        'level': value.level,
        'status': value.status,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'renewal_date': value.renewal_date === undefined ? undefined : (value.renewal_date === null ? null : value.renewal_date.toISOString()),
        'expiration_date': value.expiration_date === undefined ? undefined : (value.expiration_date === null ? null : value.expiration_date.toISOString()),
        'cancelled_on': value.cancelled_on === undefined ? undefined : (value.cancelled_on === null ? null : value.cancelled_on.toISOString()),
    };
}


